import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

type RegisterRequest = {
  requestId: string;
};

export type RejectRegisterRequestParams = RequestConfig<RegisterRequest>;

export const rejectRegisterRequest = async ({
  params,
  config
}: RejectRegisterRequestParams) =>
  api.put(
    `/api/registrationrequests/${params.requestId}/reject`,
    params,
    config
  );
